import React from "react";
import { motion } from "framer-motion";

const LEAF =
  "M32 4C20 14 8 20 8 34c0 12 10 22 24 26 14-4 24-14 24-26C56 20 44 14 32 4Z";

function Sticker({ children, className, y }) {
  return (
    <motion.div
      className={`absolute pointer-events-none select-none ${className}`}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.8, duration: 0.8, type: "spring" }}
      style={{ y }}
    >
      <motion.div
        animate={{ rotate: [0, 8, -6, 0], y: [0, -10, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}

export default function FloatingStickers() {
  return (
    <>
      <Sticker className="top-[18%] left-[6%] w-16 h-16 sm:w-20 sm:h-20">
        <svg viewBox="0 0 64 64" className="w-full h-full">
          <path d={LEAF} fill="#0C4A28" />
          <path d="M32 8 L32 56" stroke="#FFFDF8" strokeWidth="2" opacity="0.5" />
        </svg>
      </Sticker>
      <Sticker className="top-[62%] left-[10%] w-12 h-12 sm:w-14 sm:h-14">
        <svg viewBox="0 0 64 64" className="w-full h-full">
          <circle cx="32" cy="32" r="26" fill="#FFFDF8" />
          <circle cx="32" cy="32" r="20" fill="#E03A00" />
          <circle cx="24" cy="26" r="3" fill="#FFFDF8" opacity="0.7" />
        </svg>
      </Sticker>
      <Sticker className="top-[24%] right-[8%] w-14 h-14 sm:w-16 sm:h-16">
        <svg viewBox="0 0 64 64" className="w-full h-full">
          <path d={LEAF} fill="#0C4A28" transform="rotate(40 32 32)" />
        </svg>
      </Sticker>
      <Sticker className="bottom-[14%] right-[12%] w-16 h-16">
        <svg viewBox="0 0 64 64" className="w-full h-full">
          <circle cx="32" cy="32" r="24" fill="#FFFDF8" />
          <path d="M32 12 L52 44 L12 44 Z" fill="#FF5003" />
        </svg>
      </Sticker>
    </>
  );
}
